export default function (directive, binding) {
  if (typeof binding.value !== 'function') {
    console.warn(`[v-${directive}:] provided expression`, binding.expression, 'is not a function.');
    return false;
  }

  return true;
}
